import { getField, updateField } from 'vuex-map-fields';

const getters = {
    getField,

    payment_test_mode: state => {
        if (!state.selected_site) {
            return '';
        }
        return Boolean(parseInt(state.selected_site.site_settings.filter(setting => setting.name === 'payment_gateway_test_mode')[0].value));
    },
    stripe_key: (state, getters) => {
        if (!state.selected_site) {
            return '';
        }

        var key = null;

        if (getters.payment_test_mode) {
            key = state.selected_site.site_settings.filter(setting => setting.name === 'payment_gateway_test_api_key')[0].value
        } else {
            key = state.selected_site.site_settings.filter(setting => setting.name === 'payment_gateway_live_api_key')[0].value
        }
        console.log("Stripe test mode -", getters.payment_test_mode);
        console.log("Strip api key - ", key);
        return key;
    },
    google_maps_api_key: state => {
        if (!state.selected_site) {
            return '';
        }
        return state.selected_site.site_settings.filter(setting => setting.name === 'payment_gateway_live_api_key')[0].value
    }
};

const state = {
    step: 0,

    selected_site: null,
    selected_user_id: '',
    customer_info: null,
    customer_logo: null,
    customer_logo_id: '',
    selected_products: [],
    customization_type: '',
    pantones: [
        {name: ''}, {name: ''}, {name: ''}
    ],

    checkout_data: {}
};

const mutations = {
    updateField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};